import moment from 'moment';
import DateUtils from 'lib/DateUtils';
import PhoneUtils from 'lib/PhoneUtils';

export const NO_DATA = '-- No Data --';

const formatAddress = (address) => {
    if (!address) return '';
    const parts = [
        address.address1,
        address.address2,
        [address.city, address.state].filter(Boolean).join(', '),
        address.zipCode,
    ].filter(Boolean);
    return parts.join(' ');
};

const formatEmployment = (employment) => {
    if (!employment) return '';
    const parts = [
        employment.employer,
        employment.title,
        employment.monthlyIncome != null ? `$${employment.monthlyIncome}` : null,
    ].filter(Boolean);
    return parts.join(' — ');
};

const maskSsn = (ssn) => {
    if (!ssn) return '';
    const digits = String(ssn).replace(/\D/g, '');
    if (digits.length < 4) return ssn;
    return `***-**-${digits.slice(-4)}`;
};

export const MERGE_FIELDS = [
    { key: 'firstName', label: 'First Name', overrideField: 'firstName' },
    { key: 'middleName', label: 'Middle Name', overrideField: 'middleName' },
    { key: 'lastName', label: 'Last Name', overrideField: 'lastName' },
    { key: 'email', label: 'Email', overrideField: 'email' },
    {
        key: 'cellPhone',
        label: 'Phone',
        overrideField: 'cellPhone',
        getDisplayValue: (customer) => PhoneUtils.formatPhone(customer.cellPhone) || customer.cellPhone || '',
    },
    {
        key: 'homePhone',
        label: 'Home Phone',
        overrideField: 'homePhone',
        getDisplayValue: (customer) => PhoneUtils.formatPhone(customer.homePhone) || customer.homePhone || '',
    },
    {
        key: 'workPhone',
        label: 'Work Phone',
        overrideField: 'workPhone',
        getDisplayValue: (customer) => PhoneUtils.formatPhone(customer.workPhone) || customer.workPhone || '',
    },
    {
        key: 'ssn',
        label: 'SSN',
        overrideField: 'ssn',
        getDisplayValue: (customer) => maskSsn(customer.ssn),
        getCompareValue: (customer) => customer.ssn || '',
    },
    { key: 'dln', label: 'DLN', overrideField: 'dln' },
    {
        key: 'address',
        label: 'Address',
        overrideField: 'currentAddressId',
        getDisplayValue: (customer) => formatAddress(customer.currentAddress),
        getCompareValue: (customer) => customer.currentAddressId || formatAddress(customer.currentAddress),
    },
    {
        key: 'dob',
        label: 'Date of Birth',
        overrideField: 'dob',
        getDisplayValue: (customer) => (customer.dob ? DateUtils.format(moment(customer.dob).utcOffset(0)) : ''),
    },
    {
        key: 'employment',
        label: 'Employment',
        overrideField: 'currentEmploymentId',
        getDisplayValue: (customer) => formatEmployment(customer.currentEmployment),
        getCompareValue: (customer) => customer.currentEmploymentId || formatEmployment(customer.currentEmployment),
    },
];

export const getFieldDisplayValue = (field, customer) => {
    if (!customer) return '';
    if (field.getDisplayValue) return field.getDisplayValue(customer) || '';
    const value = customer[field.key];
    return value == null ? '' : String(value);
};

export const getFieldCompareValue = (field, customer) => {
    if (!customer) return '';
    if (field.getCompareValue) return field.getCompareValue(customer) || '';
    return getFieldDisplayValue(field, customer);
};

export const hasFieldConflict = (field, customers) => {
    const values = customers.map((customer) => getFieldCompareValue(field, customer));
    const normalized = values.map((value) => String(value || '').trim().toLowerCase());
    return normalized.some((value) => value !== normalized[0]);
};
